import { ContentType, Result } from '@standardnotes/domain-core';
import { CreateDecryptedBackupFileContextPayload, CreateEncryptedBackupFileContextPayload, isDecryptedPayload, isEncryptedPayload, } from '@standardnotes/models';
import { ProtocolVersionLatest } from '@standardnotes/common';
import { isNotUndefined } from '@standardnotes/utils';
export class CreateDecryptedBackupFile {
    constructor(payloads, protections) {
        this.payloads = payloads;
        this.protections = protections;
    }
    async execute() {
        if (!(await this.protections.authorizeBackupCreation())) {
            return Result.fail('Failed to authorize backup creation');
        }
        const payloads = this.payloads.nonDeletedItems.filter((item) => item.content_type !== ContentType.TYPES.ItemsKey);
        const data = {
            version: ProtocolVersionLatest,
            items: payloads
                .map((payload) => {
                if (isDecryptedPayload(payload)) {
                    return CreateDecryptedBackupFileContextPayload(payload);
                }
                else if (isEncryptedPayload(payload)) {
                    return CreateEncryptedBackupFileContextPayload(payload);
                }
                return undefined;
            })
                .filter(isNotUndefined),
        };
        return Result.ok(data);
    }
}
